var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3474 47.347C53.7569 47.347 56.5209 44.5831 56.5209 41.1735C56.5209 37.764 53.7569 35 50.3474 35C46.9378 35 44.1738 37.764 44.1738 41.1735C44.1738 44.5831 46.9378 47.347 50.3474 47.347Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.6941 58.9218C62.6941 62.7575 62.6941 65.867 50.347 65.867C38 65.867 38 62.7575 38 58.9218C38 55.086 43.528 51.9766 50.347 51.9766C57.1662 51.9766 62.6941 55.086 62.6941 58.9218Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArea);
export default __webpack_public_path__ + "static/media/upload_area.51e0abaae411e74261b599e6af0ecb5e.svg";
export { ForwardRef as ReactComponent };